// A size in the unit somebody would say it in. /hasher reads a file to digest it and /hex reads one to edit it, and
// both have a number of bytes to put on screen; the second copy is the one that quietly stops agreeing with the first.
export function byteSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} ${bytes === 1 ? "byte" : "bytes"}`;
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < BYTE_UNITS.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${value.toFixed(1)} ${BYTE_UNITS[unit]}`;
}

const BYTE_UNITS = ["KiB", "MiB", "GiB", "TiB"];
